import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/common/Layout';
import { ToastContainer, Slide } from 'react-toastify';

import './css/custom-styles.scss';
import './css/axa.scss';
import "./css/axa-lib/css/axaDesignSystemLib.css"
import 'react-toastify/dist/ReactToastify.css';
import LocalStorageChecker from './components/common/LocalStorageChecker';
import { UserContext } from './auth/auth0-provider-with-history';

const App = () => {
    const { userData } = useContext(UserContext);
    const loginType = userData.loginType || localStorage.getItem('loginType');

    return (
        <>
            <Layout>
                <LocalStorageChecker />
                <Routes>
                    {AppRoutes.filter(x => x.allow.some(y => y === loginType) || x.allow.length === 0).map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </Layout>
            <ToastContainer
                theme="colored"
                transition={Slide}
                className="mt-5"
            />
        </>
    );
}

export default App;
